import React, { useEffect, useState } from "react";
import { PreventNonNumeric } from "../../Functions/Utils";

// import { PreventNonNumeric } from "../../Functions/Utils";

function InputComponent({ data, onChange, value, handleSubmit, loopCount, count }) {
  const { mainHead = "", placeholder, type, name, preventData, max, regex } = data || {};
  // //console.log(name)
  const [Value, setValue] = useState('')
  useEffect(() => {
    // console.info('-------> input comp',value)
    if (value) {
      // ""
      // setValue(value)
    }
    return () => {
      // ""
      setValue('')
    }
  }, [value])
  // alert(count)
  return (

    <>

      <p className="text-start mb-1 light_gray font_14 fw_500 pt-1">{placeholder}</p>
      <input
        type={type}
        className="mb-2 mb-md-0 form-control text-center ls_10x "
        name={name}
        // placeholder={placeholder}
        value={value[name] || ''}
        onChange={(e) => onChange(e, max, regex)}
        // onKeyDown={PreventNonNumeric}
        autoComplete="off"

      />
      {loopCount == count &&

        <button
          type="submit"
          className="btn mt-2 px_btn btn-master2 px-4  w-100 fw_500"
          onClick={handleSubmit}
        //  disabled={""}
        >
          Submit
        </button>
      }
    </>

  );
}

export default InputComponent;
